import * as React from "react";
import { Checkbox } from "../Elements/Checkbox";
import "./UserConsent.scss";

export const UserConsentCheck = ({
    onChange,
    defaultChecked
}: {
    onChange: CallableFunction;
    defaultChecked?: boolean;
}): JSX.Element => (
    <Checkbox
        label={"Piekrītu personas datu apstrādei"}
        defaultChecked={defaultChecked || false}
        required={true}
        onChange={(checked) => onChange(checked)}
    ></Checkbox>
);
